export type CheckoutVariant = 'classic' | 'modern'

/** Shops retain the established checkout unless they explicitly select modern. */
export const resolveCheckoutVariant = (value: unknown): CheckoutVariant => (
  value === 'modern' ? 'modern' : 'classic'
)

export const usesModernCheckoutChrome = (variant: CheckoutVariant, pathname: string) => (
  variant === 'modern' && pathname === '/kasse'
)

/** Use Next's pathname so query strings and checkout steps cannot change the footer. */
export const usesCompactCheckoutFooter = (enabled: boolean, pathname: string) => (
  enabled && (pathname === '/warenkorb' || pathname === '/kasse')
)
